import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CompomentLien from "../../../components/public/orgunit/ComponentLien";
import illusRituels from "../../../assets/images/illusRituels.jpg";
import illusTempsCollectifs from "../../../assets/images/illusTempsCollectifs.jpg";
import illusPartiesPrenantes from "../../../assets/images/illusPartiesPrenantes.jpg";
import illusRoles from "../../../assets/images/illusRoles.jpg";
import { toDateFR } from "../../../utils/datesHeures";
import { MdOutlinePushPin, MdPushPin } from "react-icons/md";
import { useSelector } from "react-redux";
import ComponentColideeButtonEspaces from "./ComponentColideeButtonEspaces";

const ComponentOrgUnit = (props) => {
  const { t } = useTranslation();
  const { orgunitObject, isPinned } = props;
  const [illustration, setIllustration] = useState("");
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  useEffect(() => {
    if (orgunitObject.cardPic) {
      setIllustration(
        process.env.REACT_APP_URL_EXPRESS + "images/orgunit/small/" + orgunitObject.cardPic,
      );
    } else {
      switch (orgunitObject.type) {
        case "Rituel":
          setIllustration(
            ReduxInstance.rituelPic
              ? process.env.REACT_APP_URL_EXPRESS +
                  "images/instance/small/" +
                  ReduxInstance.rituelPic
              : illusRituels,
          );
          break;
        case "Temps collectif":
          setIllustration(
            ReduxInstance.tempscollectifPic
              ? process.env.REACT_APP_URL_EXPRESS +
                  "images/instance/small/" +
                  ReduxInstance.tempscollectifPic
              : illusTempsCollectifs,
          );
          break;
        case "Rôle":
          setIllustration(
            ReduxInstance.rolePic
              ? process.env.REACT_APP_URL_EXPRESS + "images/instance/small/" + ReduxInstance.rolePic
              : illusRoles,
          );
          break;
        case "Partie prenante":
          setIllustration(
            ReduxInstance.partieprenantePic
              ? process.env.REACT_APP_URL_EXPRESS +
                  "images/instance/small/" +
                  ReduxInstance.partieprenantePic
              : illusPartiesPrenantes,
          );
          break;
        default:
          console.log("souci pas d'images");
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card
      id={"orgunit_" + orgunitObject._id}
      className={
        isPinned
          ? "d-flex flex-column justify-content-between align-items-center  componentOrgunit m-2 isPinned"
          : "d-flex flex-column justify-content-between align-items-center  componentOrgunit m-2"
      }
    >
      <span className="overflowInContent">
        <Link to={`/orgunits/${orgunitObject._id}`}>
          <Card.Img variant="top" src={illustration} />
        </Link>
        <Card.Body>
          <Link to={`/orgunits/${orgunitObject._id}`}>
            <Card.Text className="text-end">
              {orgunitObject.type === "Rituel" && t("public.componentOrgUnit.type1")}
              {orgunitObject.type === "Temps collectif" && t("public.componentOrgUnit.type2")}
              {orgunitObject.type === "Rôle" && t("public.componentOrgUnit.type3")}
              {orgunitObject.type === "Partie prenante" && t("public.componentOrgUnit.type4")}
              {(orgunitObject.type === "Rituel" || orgunitObject.type === "Temps collectif") &&
              orgunitObject.frequence ? (
                <>
                  {" - "}
                  {orgunitObject.frequence === "Hebdomadaire" &&
                    t("public.componentOrgUnit.frequenceHebdomadaire")}
                  {orgunitObject.frequence === "Mensuel" &&
                    t("public.componentOrgUnit.frequenceMensuel")}
                  {orgunitObject.frequence === "Annuel" &&
                    t("public.componentOrgUnit.frequenceAnnuel")}
                </>
              ) : (
                ""
              )}
              {orgunitObject.dateObjectCalendar && (
                <span>
                  <br />
                  {t("public.componentOrgUnit.lastRencontre")}{" "}
                  {toDateFR(orgunitObject.dateObjectCalendar)}
                </span>
              )}
            </Card.Text>
            <Card.Title>{orgunitObject.nom}</Card.Title>
          </Link>
          {/* {orgunitObject.liens.map((item, index) => (
            <CompomentLien icone={item.icone} url={item.url} key={index} />
          ))} */}
        </Card.Body>
      </span>
      {/* {orgunitObject.liens.filter((item) => item.icone === "colidee").length > 0 && (
        <ComponentColideeButtonEspaces
          espacesColideeOrgunit={orgunitObject.liens.filter((item) => item.icone === "colidee")}
        />
      )} */}
    </Card>
  );
};

export default ComponentOrgUnit;
